import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { useSelectedAchievements } from '../../core/achievements/achievements.hook';
import { useMe } from '../../profile/hooks';
import { achievementsPropTypes, containerTypePropTypes } from '../../propTypes';
import { replaceValues } from '../../utils/stringUtils';
import AchievementBadge from '../AchievementBadge';
import BlockContainer from '../BlockContainer';
import './HtmlBlock.scss';

function HtmlBlock(props) {
  const { id, achievements, title, content, containerType, _id } = props;

  const user = useMe();
  const { ids: achievementsIds } = achievements || {};
  const blockAchievements = useSelectedAchievements(achievementsIds);
  if (!content) return null;

  return (
    <BlockContainer id={id} type={containerType} header={title} className={cx('block--html', _id)}>
      {blockAchievements && (
        <div className="achievements-badge-container" style={{ display: 'flex' }}>
          {blockAchievements.map((a) => (
            <AchievementBadge
              key={a._id}
              className={cx('achievement-image', a._id)}
              achievement={a}
              height={40}
            />
          ))}
        </div>
      )}
      <div dangerouslySetInnerHTML={{ __html: replaceValues(content, { user }) }} />
    </BlockContainer>
  );
}

HtmlBlock.defaultProps = {
  achievements: undefined,
  content: undefined,
  containerType: 'segment-light',
  id: PropTypes.string,
  title: undefined,
};

HtmlBlock.propTypes = {
  _id: PropTypes.string.isRequired,
  achievements: achievementsPropTypes,

  content: PropTypes.string,
  containerType: containerTypePropTypes,
  id: undefined,
  title: PropTypes.string,
};

export default HtmlBlock;
